// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./core/images/DASHBackground.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./core/images/DASHBackground2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./core/images/DASHBackground3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./core/images/DASHBackground4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./core/images/DASHBackground5.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  box-sizing: border-box;
  margin: 0;
  /* background:var(--main-color); */
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}


body {
  background: #f3f6f4;
}
.prevent-select {
  -webkit-user-select: none;
  user-select: none;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-size: 13.5px;
}

tr:nth-child(even) {
  background-color: #fff;
}
#wrapper {
  margin-right: auto;
  margin-left: auto;
  max-width: 1360px;
  padding: 4px;
}
.scroll::-webkit-scrollbar {
  display: none;
}
#wavyeffect {
  --mask:
    radial-gradient(169.62px at 50% calc(100% - 232.20px),#000 99%,#0000 101%) calc(50% - 172px) 0/344px 100%,
    radial-gradient(169.62px at 50% calc(100% + 146.20px),#0000 99%,#000 101%) 50% calc(100% - 86px)/344px 100% repeat-x;
  -webkit-mask: var(--mask);
          mask: var(--mask);
}


#glassMorph {
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    background-color: rgba(17, 25, 40, 0.75);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.125);
}
/* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: #5995e3 #ffffff;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 12px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #5995e3;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }

.color-up {
  position: absolute;
  top: 0;
  height: 25vh;
  background: rgb(255,255,255);
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(105,254,253,1) 70%, rgba(170,113,240,1) 100%);
}

.app {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.tag-list {
  width: 80rem;
  max-width: 90vw;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 1rem 0;
  position: relative;
  padding: 1.5rem 0;
  overflow: hidden;
}

.inner {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  animation-name: loop;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: var(--direction);
  animation-duration: var(--duration);
}

.tag {
  display: flex;
  align-items: center;
  gap: 0 0.2rem;
  color: #000000;
  font-size: 1rem;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 0.4rem;
  text-align: center;
  padding: 0.7rem 1rem;
  margin-right: 1rem;
  max-width: 300px;
  width: 250px;
}

.fade {
  pointer-events: none;
  background: linear-gradient(
    90deg,
    #f3f6f4,
    transparent 30%,
    transparent 70%,
    #f3f6f4
  );
  position: absolute;
  inset: 0;
}

@keyframes loop {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.moving-arrow {
  animation: moveRightAndBack 4s ease-in-out infinite; /* Set animation properties */
}
#DASHbackground {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-attachment: fixed;
}
#DASHbackground2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-attachment: fixed;
}
#DASHbackground3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-attachment: fixed;
}
#DASHbackground4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-attachment: fixed;
}
#DASHbackground5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-attachment: fixed;
}
#rtlanimation{
  animation: rtlanimateBg 14s linear infinite;
  background-image: linear-gradient(90deg,#11c4be,#e69138,#ff5c5c,#11c4be);
  background-size: 300% 100%;
}
@keyframes rtlanimateBg {
  0% { background-position: 0% 0%; }
  100% { background-position: 100% 0%; }
}

.big-toast {
  max-width: 400px;
}

@keyframes moveRightAndBack {
  0% {
    transform: translateX(0); /* Starting position */
  }
  50% {
    transform: translateX(20px); /* Move right by 200px */
  }
  100% {
    transform: translateX(0); /* Return to the original position */
  }
}

.wave {
  display: block;
  position: relative;
  height: 40px;
  width: 100%;
  background: rgb(57, 27, 112);
}

.wave:before {
  content: "";
  display: block;
  position: absolute;
  border-radius: 100%;
  width: 200%;
  height: 300px;
  background-color: white;
  right: 0;
  top: -40px;
}

.wave:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 100%;
  width: 200%;
  height: 300px;
  background-color: rgb(57, 27, 112);
  left: 0;
  top: -240px;
  clip-path: ellipse(100% 15% at 100% 0%);
}

#google_translate_element {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

/* Target the select dropdown */
.goog-te-combo {
  background-color: #f9fafb; /* Tailwind: bg-gray-50 */
  border: 1px solid #d1d5db; /* Tailwind: border-gray-300 */
  padding: 0.5rem; /* Tailwind: p-2 */
  border-radius: 0.375rem; /* Tailwind: rounded-md */
  color: #111827; /* Tailwind: text-gray-900 */
  font-size: 1rem; /* Tailwind: text-base */
  outline: none;
  transition: all 0.2s ease;
}

/* Hover and focus states */
.goog-te-combo:hover, .goog-te-combo:focus {
  border-color: #3b82f6; /* Tailwind: border-blue-500 */
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5); /* Tailwind: ring-2 ring-blue-500 */
}
.VIpgJd-ZVi9od-ORHb-OEVmcd {
  display: none !important;
}
.translated-ltr {
  margin-top: -40px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,UAAU;EACV,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,kCAAkC;EAIlC,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AALzC;;;AASA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EAEzB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE;;wHAEsH;EACtH,yBAAyB;UACjB,iBAAiB;AAC3B;;;AAGA;IACI,0CAA0C;IAC1C,kDAAkD;IAClD,wCAAwC;IACxC,mBAAmB;IACnB,4CAA4C;AAChD;AACA,8BAA8B;EAC5B,YAAY;EACZ;IACE,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEF;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,4BAA4B;EAC5B,6GAA6G;AAC/G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB;;;;;;GAMC;EACD,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mDAAmD,EAAE,6BAA6B;AACpF;AACA;EACE,yDAAyD;EACzD,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,yDAA0D;EAC1D,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,yDAA0D;EAC1D,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,yDAA0D;EAC1D,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,yDAA0D;EAC1D,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,2CAA2C;EAC3C,wEAAwE;EACxE,0BAA0B;AAC5B;AACA;EACE,KAAK,0BAA0B,EAAE;EACjC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB,EAAE,sBAAsB;EAClD;EACA;IACE,2BAA2B,EAAE,wBAAwB;EACvD;EACA;IACE,wBAAwB,EAAE,oCAAoC;EAChE;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,OAAO;EACP,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB,EAAE,yBAAyB;EACpD,yBAAyB,EAAE,8BAA8B;EACzD,eAAe,EAAE,kBAAkB;EACnC,uBAAuB,EAAE,yBAAyB;EAClD,cAAc,EAAE,4BAA4B;EAC5C,eAAe,EAAE,wBAAwB;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB,EAAE,8BAA8B;EACrD,6CAA6C,EAAE,mCAAmC;AACpF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;300;400;500;600;700;800;900&display=swap\");\n* {\n  padding: 0;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  box-sizing: border-box;\n  margin: 0;\n  /* background:var(--main-color); */\n}\n\n*{\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n\nbody {\n  background: #f3f6f4;\n}\n.prevent-select {\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\ntable {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%;\n}\n\ntd, th {\n  border: 1px solid #dddddd;\n  text-align: left;\n  padding: 8px;\n  font-size: 13.5px;\n}\n\ntr:nth-child(even) {\n  background-color: #fff;\n}\n#wrapper {\n  margin-right: auto;\n  margin-left: auto;\n  max-width: 1360px;\n  padding: 4px;\n}\n.scroll::-webkit-scrollbar {\n  display: none;\n}\n#wavyeffect {\n  --mask:\n    radial-gradient(169.62px at 50% calc(100% - 232.20px),#000 99%,#0000 101%) calc(50% - 172px) 0/344px 100%,\n    radial-gradient(169.62px at 50% calc(100% + 146.20px),#0000 99%,#000 101%) 50% calc(100% - 86px)/344px 100% repeat-x;\n  -webkit-mask: var(--mask);\n          mask: var(--mask);\n}\n\n\n#glassMorph {\n    backdrop-filter: blur(16px) saturate(180%);\n    -webkit-backdrop-filter: blur(16px) saturate(180%);\n    background-color: rgba(17, 25, 40, 0.75);\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.125);\n}\n/* ===== Scrollbar CSS ===== */\n  /* Firefox */\n  * {\n    scrollbar-width: auto;\n    scrollbar-color: #5995e3 #ffffff;\n  }\n\n  /* Chrome, Edge, and Safari */\n  *::-webkit-scrollbar {\n    width: 12px;\n  }\n\n  *::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  *::-webkit-scrollbar-thumb {\n    background-color: #5995e3;\n    border-radius: 10px;\n    border: 3px solid #ffffff;\n  }\n\n.color-up {\n  position: absolute;\n  top: 0;\n  height: 25vh;\n  background: rgb(255,255,255);\n  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(105,254,253,1) 70%, rgba(170,113,240,1) 100%);\n}\n\n.app {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.tag-list {\n  width: 80rem;\n  max-width: 90vw;\n  display: flex;\n  flex-shrink: 0;\n  flex-direction: column;\n  gap: 1rem 0;\n  position: relative;\n  padding: 1.5rem 0;\n  overflow: hidden;\n}\n\n.inner {\n  display: flex;\n  width: fit-content;\n  animation-name: loop;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  animation-direction: var(--direction);\n  animation-duration: var(--duration);\n}\n\n.tag {\n  display: flex;\n  align-items: center;\n  gap: 0 0.2rem;\n  color: #000000;\n  font-size: 1rem;\n  justify-content: center;\n  flex-direction: column;\n  background-color: #ffffff;\n  border-radius: 0.4rem;\n  text-align: center;\n  padding: 0.7rem 1rem;\n  margin-right: 1rem;\n  max-width: 300px;\n  width: 250px;\n}\n\n.fade {\n  pointer-events: none;\n  background: linear-gradient(\n    90deg,\n    #f3f6f4,\n    transparent 30%,\n    transparent 70%,\n    #f3f6f4\n  );\n  position: absolute;\n  inset: 0;\n}\n\n@keyframes loop {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.moving-arrow {\n  animation: moveRightAndBack 4s ease-in-out infinite; /* Set animation properties */\n}\n#DASHbackground {\n  background-image: url('./core/images/DASHBackground.svg');\n  background-size: cover;\n  background-attachment: fixed;\n}\n#DASHbackground2 {\n  background-image: url('./core/images/DASHBackground2.svg');\n  background-size: cover;\n  background-attachment: fixed;\n}\n#DASHbackground3 {\n  background-image: url('./core/images/DASHBackground3.svg');\n  background-size: cover;\n  background-attachment: fixed;\n}\n#DASHbackground4 {\n  background-image: url('./core/images/DASHBackground4.svg');\n  background-size: cover;\n  background-attachment: fixed;\n}\n#DASHbackground5 {\n  background-image: url('./core/images/DASHBackground5.svg');\n  background-size: cover;\n  background-attachment: fixed;\n}\n#rtlanimation{\n  animation: rtlanimateBg 14s linear infinite;\n  background-image: linear-gradient(90deg,#11c4be,#e69138,#ff5c5c,#11c4be);\n  background-size: 300% 100%;\n}\n@keyframes rtlanimateBg {\n  0% { background-position: 0% 0%; }\n  100% { background-position: 100% 0%; }\n}\n\n.big-toast {\n  max-width: 400px;\n}\n\n@keyframes moveRightAndBack {\n  0% {\n    transform: translateX(0); /* Starting position */\n  }\n  50% {\n    transform: translateX(20px); /* Move right by 200px */\n  }\n  100% {\n    transform: translateX(0); /* Return to the original position */\n  }\n}\n\n.wave {\n  display: block;\n  position: relative;\n  height: 40px;\n  width: 100%;\n  background: rgb(57, 27, 112);\n}\n\n.wave:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border-radius: 100%;\n  width: 200%;\n  height: 300px;\n  background-color: white;\n  right: 0;\n  top: -40px;\n}\n\n.wave:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border-radius: 100%;\n  width: 200%;\n  height: 300px;\n  background-color: rgb(57, 27, 112);\n  left: 0;\n  top: -240px;\n  clip-path: ellipse(100% 15% at 100% 0%);\n}\n\n#google_translate_element {\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n/* Target the select dropdown */\n.goog-te-combo {\n  background-color: #f9fafb; /* Tailwind: bg-gray-50 */\n  border: 1px solid #d1d5db; /* Tailwind: border-gray-300 */\n  padding: 0.5rem; /* Tailwind: p-2 */\n  border-radius: 0.375rem; /* Tailwind: rounded-md */\n  color: #111827; /* Tailwind: text-gray-900 */\n  font-size: 1rem; /* Tailwind: text-base */\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n/* Hover and focus states */\n.goog-te-combo:hover, .goog-te-combo:focus {\n  border-color: #3b82f6; /* Tailwind: border-blue-500 */\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5); /* Tailwind: ring-2 ring-blue-500 */\n}\n.VIpgJd-ZVi9od-ORHb-OEVmcd {\n  display: none !important;\n}\n.translated-ltr {\n  margin-top: -40px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
